"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var ProjectsBlock = /** @class */ (function (_super) {
    tslib_1.__extends(ProjectsBlock, _super);
    function ProjectsBlock() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProjectsBlock.prototype.render = function () {
        var items = this.props.items;
        return (react_1.default.createElement("div", { className: "projects-block" },
            react_1.default.createElement("div", { className: "projects-block__list" }, items.map(function (item) { return (react_1.default.createElement(exports.ProjectItemBlock, { key: item.slug, item: item })); })),
            react_1.default.createElement("a", { href: "/projects", className: "projects-block__link" }, "\u041F\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0432\u0441\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u044B")));
    };
    ProjectsBlock = tslib_1.__decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], ProjectsBlock);
    return ProjectsBlock;
}(react_1.default.Component));
exports.ProjectsBlock = ProjectsBlock;
exports.ProjectItemBlock = function (_a) {
    var _b = _a.item, slug = _b.slug, images = _b.images, title = _b.title;
    return (react_1.default.createElement("a", { href: "/projects/" + slug, className: "projects-block__item" },
        react_1.default.createElement("span", { className: "projects-block__item-image", style: {
                backgroundImage: "url(" + images[0].url + ")",
            } }),
        react_1.default.createElement("span", { className: "projects-block__item-title", title: title }, title)));
};
